
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "accounts",
  "title": "Accounts",
  "sidebar_label": "Accounts"
};
const slug = 'accounts';
const tableOfContents = [{
  "title": "Account",
  "slug": "account",
  "children": []
}, {
  "title": "Account Attributes",
  "slug": "account-attributes",
  "children": []
}, {
  "title": "Flexible Account creation",
  "slug": "flexible-account-creation",
  "children": []
}, {
  "title": "Accounts (Users/Profiles)",
  "slug": "accounts-users-profiles",
  "children": []
}, {
  "title": "Account Category",
  "slug": "account-category",
  "children": []
}, {
  "title": "Approve Accounts",
  "slug": "approve-accounts",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <_Heading level={2} id={"account"} nextElement={{
      "type": "paragraph"
    }}>Account</_Heading>
    <p>{`APPLICABLE ONLY for MARKETPLACES - C2C/P2P`}</p>
    <p><a parentName="p" {...{
        "href": "https://developer.tradly.app/#65258420-75cd-4060-81e2-f05a7c4183eb"
      }}>{`API Reference`}</a>{` | `}<a parentName="p" {...{
        "href": "https://superadmin.tradly.app/accounts"
      }}>{`Visit SuperAdmin`}</a></p>
    <p>{`When a user register in the app, he will be optionally able to create accounts based on his purpose of joining the platform. `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`For a retail product marketplace like Etsy/AliExpress, Accounts are Stores Profiles. `}</li>
      <li parentName="ul">{`For an educational marketplace like Coursera, Udemy, Accounts are Tutor Profiles`}</li>
      <li parentName="ul">{`For a property marketplace platform like Airbnb, it is called as Tenant Profile.
We call them generally as accounts, and it may vary based on your business model.`}</li>
    </ul>
    <p>{`##Video: Configuring Accounts`}</p>
    <div class="aspect-w-16 aspect-h-9">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/T1sN1C9qUSI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    <_Heading level={2} id={"account-attributes"} nextElement={{
      "type": "paragraph"
    }}>Account Attributes</_Heading>
    <p><a parentName="p" {...{
        "href": "https://superadmin.tradly.app/account-attributes"
      }}>{`Account Attributes in SuperAdmin`}</a></p>
    <p>{`You can create additional attributes(fields) of information to be collected when user open an account.
Example such as `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Fashion Marketplace can have location, What type of products they sell, etc`}</li>
      <li parentName="ul">{`EduTech marketplace can have Tutor availability, Expertise, Academic qualifications, etc`}</li>
      <li parentName="ul">{`Grocery Marketplace can have Shop Location, Type of product they sell, Growing method(Organic), Procurement(homemade or Direct farm buy or resell) `}</li>
    </ul>
    <_Heading level={2} id={"flexible-account-creation"} nextElement={{
      "type": "paragraph"
    }}>Flexible Account creation</_Heading>
    <p>{`As a platform owner, you can design different account creation form based on the type of accounts you have. `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`When you are building a hybrid marketplace, you want to have different stakeholders to open accounts. And the accounts perhaps need different information than the primary information.`}</li>
      <li parentName="ul">{`By Default, we only collect the Name and Description of the account registration `}</li>
      <li parentName="ul">{`You can configure additional attributes `}</li>
      <li parentName="ul">{`You can create multiple categories of accounts `}</li>
      <li parentName="ul">{`You can create additional attributes specific to an account category rather than overall `}</li>
    </ul>
    <_Heading level={2} id={"accounts-users-profiles"} nextElement={{
      "type": "paragraph"
    }}>Accounts (Users/Profiles)</_Heading>
    <p>{`This is visible only in production/live SuperAdmin panel.`}</p>
    <_Heading level={2} id={"account-category"} nextElement={{
      "type": "paragraph"
    }}>Account Category</_Heading>
    <p><img parentName="p" {...{
        "src": "/img/account-categories.png",
        "alt": " Account Categories"
      }}></img>{`
After onboarding users with simple signup, you might want to allow them to have personalised account opening. Accounts can be called in different way based on business model. `}</p>
    <p>{`So, you can have multiple account types based on user persona. You will see, through account attribute values, how this can useful having categories. To activate that, you need to set up account categories. `}</p>
    <p>{`:::important
By default, account creations fields are only image, Name, Descriptions. All other fields created via attributes.
:::`}</p>
    <p>{`##Creating Account Category
`}<a parentName="p" {...{
        "href": "https://developer.tradly.app/#f7f9e9ab-99fe-4459-8578-4b8d1312d0a4"
      }}>{`API Reference`}</a></p>
    <p><img parentName="p" {...{
        "src": "/img/add-accounts-category.png",
        "alt": " Add Account Category"
      }}></img></p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`It is simple as listing categories in all technicalities`}</li>
      <li parentName="ul">{`Select the category (Default: Parent) `}</li>
      <li parentName="ul">{`Enter category name`}</li>
      <li parentName="ul">{`Select the icon as per the dimension (square). `}</li>
      <li parentName="ul">{`Submit`}</li>
    </ul>
    <p>{`To test: You can go to app > signup up as a new user > Then, before submitting listing or open shop/account, you will be able to find the category. `}</p>
    <_Heading level={2} id={"approve-accounts"} nextElement={{
      "type": "paragraph"
    }}>Approve Accounts</_Heading>
    <p><a parentName="p" {...{
        "href": "https://developer.tradly.app/#04bc988b-a675-400f-8076-c44fe0713333"
      }}>{`API-Reference`}</a></p>
    <p>{`To be on control with the quality/business logics of your platform is “Approval” feature. You can approve or disapprove. When you activate that feature, end business accounts may not be able to add listings until you approve them. `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Under the accounts list, you can find the all the accounts and their account status `}</li>
      <li parentName="ul">{`You can approve or disapprove accounts based on your compliance and other legal procedures. `}</li>
    </ul>
    <p>{`Few example use cases:`}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">
        <p parentName="li">{`You may want to verify whether an account is legit to avoid spam listings. Or even reject an account when there is an issue with the platform’s users. `}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You may want to do business verification like company details or bank verification internally, you can collect private informations on account level and then verify this informations before approving. `}</p>
      </li>
    </ol>
    <p>{`##Creating Account Attributes
`}<img parentName="p" {...{
        "src": "/img/account-attributes.png",
        "alt": " Creating Account Attributes"
      }}></img>{`
So now you have created categories as per your plan. You can configure different fields(Attributes) that need to be in account creation page apart from default config. `}</p>
    <p>{`In the image,`}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Categories: You can find the 4 attributes as an example. And how they are configured only for specific category types. (Shop Govt registration no only for Govt. Registered shop category) `}</li>
      <li parentName="ol">{`Operation Days Attribute: Operation days can have multiple values. That’s why you can see + sign to add values. `}</li>
      <li parentName="ol">{`Attributes: A. shop registrations — mostly one number AND B. WhatsApp one number is sufficient. Both of them as they don’t have multiple values, they do not have option to ADD VALUES. We will see how they are configured on the next step. `}</li>
    </ol>
    <p><img parentName="p" {...{
        "src": "/img/account-attributes1.png",
        "alt": " Account Attributes Creation"
      }}></img>{`
Accounts > Attributes > Add Attributes.`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`These steps lead you to create attributes as shown in the image. `}</li>
      <li parentName="ul">{`Currently, it shows how the “Shop Govt Registration No” has been created. `}</li>
      <li parentName="ul">{`You can make the attributes (fields to be entered) as optional or mandatory as well. `}</li>
      <li parentName="ul">{`And this attribute has been configured only for “Govt.Registered Shop.”`}</li>
    </ul>
    <p><img parentName="p" {...{
        "src": "/img/Attribute-types.png",
        "alt": "Attribute Types"
      }}></img>{`
So, when you create attributes, you must need to select the type of attributes. Currently, we have 4 types of attributes and others will be released progressively. `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Field Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Example`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Single Select`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Gender`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`- Male OR Female`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Multi Select`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Available sizes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`S, M, L, XXL`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Single Value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Phone number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`+60123456789`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Multi Value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sizes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`32,34,36`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`##Adding attribute values
`}<img parentName="p" {...{
        "src": "/img/attribute-values.png",
        "alt": "Attribute Values"
      }}></img></p>
    <p>{`In the “Operation Days” Attribute values which is a multi value, you can find 7days we have added there. It can be used creatively in many ways. `}</p>
    <p>{`##Auto approval having issues
Q: I have enabled auto-account approval and listing approval, but the items are not approved yet`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`For existing accounts, the configuration will not approve by itself. It needs to approve manually first and then auto-approve. `}</li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
